/* ==========================================================================
   Dorantea — comportamiento propio (v2)
   ========================================================================== */
(function () {
  'use strict';

  if (window.__mtInit) return;
  window.__mtInit = true;

  var sinMovimiento = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --- Reveals ----------------------------------------------------------- */
  var observador = null;

  function obtenerObservador() {
    if (observador) return observador;
    if (!('IntersectionObserver' in window)) return null;
    observador = new IntersectionObserver(
      function (entradas) {
        entradas.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('mt-visible');
            observador.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -6% 0px' }
    );
    return observador;
  }

  function initReveals(raiz) {
    var elementos = (raiz || document).querySelectorAll('.mt-reveal');
    var obs = obtenerObservador();
    Array.prototype.forEach.call(elementos, function (el) {
      if (el.dataset.mtReveal) return;
      el.dataset.mtReveal = '1';
      if (!obs) { el.classList.add('mt-visible'); return; }
      obs.observe(el);
    });
  }

  /* --- Desplazamiento suave a un ancla ----------------------------------- */
  function initAnclas(raiz) {
    var enlaces = (raiz || document).querySelectorAll('a[href^="#"]');
    Array.prototype.forEach.call(enlaces, function (a) {
      if (a.dataset.mtAncla) return;
      a.dataset.mtAncla = '1';
      var href = a.getAttribute('href');
      if (!href || href === '#' || href.length < 2) return;

      a.addEventListener('click', function (ev) {
        var destino = document.getElementById(href.slice(1));
        if (!destino) return;
        ev.preventDefault();
        var cabecera = document.querySelector('.section-header');
        var desfase = cabecera ? cabecera.getBoundingClientRect().height : 0;
        var y = destino.getBoundingClientRect().top + window.pageYOffset - desfase - 8;
        window.scrollTo({ top: y, behavior: sinMovimiento ? 'auto' : 'smooth' });
      });
    });
  }

  /* --- Hotspots ---------------------------------------------------------- */
  function initHotspots(raiz) {
    var escenas = (raiz || document).querySelectorAll('[data-mt-hotspots]');
    Array.prototype.forEach.call(escenas, function (escena) {
      if (escena.dataset.mtInit) return;
      escena.dataset.mtInit = '1';

      var puntos = escena.querySelectorAll('.mt-punto');

      /* En pantallas pequenas la tarjeta flotante esta oculta por CSS (no cabe
         sin salirse de la pantalla), asi que el punto se enlaza con su ficha de
         la lista de abajo. Sin esto, tocar un punto en el movil no hacia nada. */
      var contenedor = escena.parentNode;
      var fichas = contenedor ? contenedor.querySelectorAll('[data-mt-detalle-indice]') : [];

      function resaltarFicha(indice) {
        var ficha = null;
        Array.prototype.forEach.call(fichas, function (f) {
          f.classList.remove('mt-destacado');
          if (f.getAttribute('data-mt-detalle-indice') === String(indice)) ficha = f;
        });
        if (!ficha) return false;
        ficha.classList.add('mt-destacado');
        if (ficha.scrollIntoView) {
          ficha.scrollIntoView({ behavior: sinMovimiento ? 'auto' : 'smooth', block: 'center' });
        }
        return true;
      }

      Array.prototype.forEach.call(puntos, function (punto) {
        punto.addEventListener('click', function (ev) {
          ev.preventDefault();
          var yaActivo = punto.classList.contains('mt-activo');
          Array.prototype.forEach.call(puntos, function (p) { p.classList.remove('mt-activo'); });
          if (!yaActivo) punto.classList.add('mt-activo');

          // solo en movil: la tarjeta no se ve, hay que llevar al usuario a la ficha
          var tarjeta = punto.querySelector('.mt-punto__tarjeta');
          var tarjetaVisible = tarjeta && getComputedStyle(tarjeta).display !== 'none';
          if (!yaActivo && !tarjetaVisible) {
            resaltarFicha(punto.getAttribute('data-mt-punto-indice'));
          }
        });
      });

      document.addEventListener('click', function (ev) {
        if (escena.contains(ev.target)) return;
        Array.prototype.forEach.call(puntos, function (p) { p.classList.remove('mt-activo'); });
      });
    });
  }

  /* --- Desplegables (FAQ y fichas del producto) --------------------------
     La altura se mueve en pixeles desde aqui. Es lo unico que funciona
     igual en todos los navegadores: el truco de grid 0fr->1fr resuelve a
     cero en algunos y el desplegable no abre nunca.                       */
  function alturaContenido(cuerpo) {
    var inner = cuerpo.firstElementChild;
    return inner ? inner.offsetHeight : cuerpo.scrollHeight;
  }

  function abrirCuerpo(cuerpo) {
    cuerpo.style.height = alturaContenido(cuerpo) + 'px';
    var alSoltar = function () {
      cuerpo.style.height = 'auto';
      cuerpo.removeEventListener('transitionend', alSoltar);
    };
    if (sinMovimiento) { cuerpo.style.height = 'auto'; return; }
    cuerpo.addEventListener('transitionend', alSoltar);
  }

  function cerrarCuerpo(cuerpo) {
    if (sinMovimiento) { cuerpo.style.height = '0px'; return; }
    cuerpo.style.height = alturaContenido(cuerpo) + 'px';
    // forzamos un reflujo para que el navegador vea el valor de partida
    void cuerpo.offsetHeight;
    cuerpo.style.height = '0px';
  }

  function initFaq(raiz) {
    var listas = (raiz || document).querySelectorAll('[data-mt-faq]');
    Array.prototype.forEach.call(listas, function (lista) {
      if (lista.dataset.mtInit) return;
      lista.dataset.mtInit = '1';
      lista.classList.add('mt-faq__lista--js');

      var items = lista.querySelectorAll('.mt-faq__item');

      function cerrarTodos(excepto) {
        Array.prototype.forEach.call(items, function (otro) {
          if (otro === excepto) return;
          if (!otro.classList.contains('mt-abierto')) return;
          otro.classList.remove('mt-abierto');
          var b = otro.querySelector('.mt-faq__boton');
          var c = otro.querySelector('.mt-faq__cuerpo');
          if (b) b.setAttribute('aria-expanded', 'false');
          if (c) { c.setAttribute('aria-hidden', 'true'); cerrarCuerpo(c); }
        });
      }

      Array.prototype.forEach.call(items, function (item) {
        var boton = item.querySelector('.mt-faq__boton');
        var cuerpo = item.querySelector('.mt-faq__cuerpo');
        if (!boton || !cuerpo) return;

        // estado inicial coherente con la clase que trae del servidor
        if (item.classList.contains('mt-abierto')) {
          cuerpo.style.height = 'auto';
        } else {
          cuerpo.style.height = '0px';
        }

        boton.addEventListener('click', function () {
          var abierto = item.classList.contains('mt-abierto');
          if (!abierto && lista.dataset.mtFaqSolo === 'true') cerrarTodos(item);

          if (abierto) {
            item.classList.remove('mt-abierto');
            boton.setAttribute('aria-expanded', 'false');
            cuerpo.setAttribute('aria-hidden', 'true');
            cerrarCuerpo(cuerpo);
          } else {
            item.classList.add('mt-abierto');
            boton.setAttribute('aria-expanded', 'true');
            cuerpo.setAttribute('aria-hidden', 'false');
            abrirCuerpo(cuerpo);
          }
        });
      });
    });
  }

  /* --- Boton magnetico ---------------------------------------------------- */
  function initBotonMagnetico(raiz) {
    if (sinMovimiento) return;
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

    var botones = (raiz || document).querySelectorAll('[data-mt-magnetico]');
    Array.prototype.forEach.call(botones, function (boton) {
      if (boton.dataset.mtInit) return;
      boton.dataset.mtInit = '1';
      var maximo = 5;

      boton.addEventListener('mousemove', function (ev) {
        var caja = boton.getBoundingClientRect();
        var dx = ev.clientX - (caja.left + caja.width / 2);
        var dy = ev.clientY - (caja.top + caja.height / 2);
        var x = Math.max(-maximo, Math.min(maximo, (dx / caja.width) * maximo * 2));
        var y = Math.max(-maximo, Math.min(maximo, (dy / caja.height) * maximo * 2));
        boton.style.transform = 'translate(' + x.toFixed(2) + 'px,' + y.toFixed(2) + 'px)';
      });
      boton.addEventListener('mouseleave', function () { boton.style.transform = ''; });
    });
  }

  /* --- Marquesina del anuncio -------------------------------------------
     Duplicamos el contenido hasta pasar del ancho de la ventana y luego
     clonamos ese conjunto una vez mas: asi translateX(-50%) es un bucle
     perfecto y sin saltos.                                                */
  function initMarquesina(raiz) {
    var pistas = (raiz || document).querySelectorAll('[data-mt-marquesina]');
    Array.prototype.forEach.call(pistas, function (pista) {
      if (pista.dataset.mtInit) return;
      pista.dataset.mtInit = '1';
      var grupo = pista.querySelector('.mt-anuncio__grupo');
      if (!grupo) return;

      var anchoGrupo = grupo.getBoundingClientRect().width;
      if (!anchoGrupo) return;

      var copias = 1;
      while (anchoGrupo * copias < window.innerWidth * 1.3 && copias < 10) {
        pista.appendChild(grupo.cloneNode(true));
        copias++;
      }
      var mitad = pista.innerHTML;
      pista.innerHTML = mitad + mitad;

      // Red de seguridad: si por lo que sea la animacion de CSS no avanza
      // (ajustes del sistema, navegador antiguo), la movemos nosotros.
      vigilarMarquesina(pista);
    });
  }

  function vigilarMarquesina(pista) {
    if (!pista.getAnimations) return;

    setTimeout(function () {
      var anims = pista.getAnimations();
      var avanzando = false;
      for (var i = 0; i < anims.length; i++) {
        if (anims[i].currentTime && anims[i].currentTime > 0) { avanzando = true; break; }
      }
      if (avanzando) return;

      // Plan B: la movemos a mano con el mismo recorrido y la misma duracion.
      // OJO: la animacion de CSS NO se cancela todavia. Si se cancela aqui y
      // luego resulta que requestAnimationFrame tampoco corre, la barra se
      // queda completamente muerta, que es peor que dejarla como estaba. Se
      // cancela dentro del primer fotograma, cuando ya sabemos que hay pintado.
      var duracion = parseFloat(getComputedStyle(pista).getPropertyValue('--mt-marq-dur')) || 35;
      var recorrido = pista.scrollWidth / 2;
      if (!recorrido) return;
      var velocidad = recorrido / (duracion * 1000); // px por milisegundo
      var invertida = pista.classList.contains('mt-anuncio__pista--reversa');
      var pausada = false;
      var anterior = null;
      var x = 0;

      pista.addEventListener('mouseenter', function () { pausada = true; });
      pista.addEventListener('mouseleave', function () { pausada = false; });

      var relevoHecho = false;

      function paso(ahora) {
        if (!relevoHecho) {
          relevoHecho = true;
          for (var j = 0; j < anims.length; j++) { anims[j].cancel(); }
          pista.style.animation = 'none';
        }
        if (anterior === null) anterior = ahora;
        var delta = ahora - anterior;
        anterior = ahora;
        if (!pausada) {
          x += velocidad * delta;
          if (x >= recorrido) x -= recorrido;
        }
        pista.style.transform = 'translateX(' + (invertida ? x : -x).toFixed(2) + 'px)';
        window.requestAnimationFrame(paso);
      }
      window.requestAnimationFrame(paso);
    }, 900);
  }

  /* --- Aviso del 10% y pestaña lateral ----------------------------------- */
  var CLAVE_AVISO = 'mt-aviso-10-cerrado';
  var CLAVE_SCROLL = 'mt-scroll-suscripcion';

  /* Guarda donde estaba la pagina antes de enviar un formulario de
     suscripcion, y la devuelve ahi al volver. Ver el comentario largo en
     initAviso: el envio recarga la pagina y sin esto se vuelve arriba. */
  function guardarScroll() {
    try { window.sessionStorage.setItem(CLAVE_SCROLL, String(window.scrollY || window.pageYOffset || 0)); } catch (e) {}
  }

  function recuperarScroll() {
    var y = null;
    try {
      y = window.sessionStorage.getItem(CLAVE_SCROLL);
      window.sessionStorage.removeItem(CLAVE_SCROLL);
    } catch (e) {}
    if (y === null) return;
    if ('scrollRestoration' in window.history) window.history.scrollRestoration = 'manual';
    window.scrollTo(0, parseInt(y, 10) || 0);
  }

  function initAviso(raiz) {
    var avisos = (raiz || document).querySelectorAll('[data-mt-aviso]');
    Array.prototype.forEach.call(avisos, function (aviso) {
      if (aviso.dataset.mtInit) return;
      aviso.dataset.mtInit = '1';

      /* Segundo cerrojo, ademas del de Liquid. En /challenge el aviso NO se
         abre pase lo que pase: Shopify pinta ahi el desafio del captcha con
         la plantilla del tema, y el aviso tapaba la casilla de hCaptcha. El
         cliente no llegaba a verificarse y se quedaba en bucle. */
      if (window.location.pathname.indexOf('/challenge') > -1) return;

      var pestana = document.querySelector('[data-mt-pestana]');
      var retraso = parseInt(aviso.dataset.mtRetraso, 10);
      if (isNaN(retraso)) retraso = 4000;

      var cerradoAntes = false;
      try { cerradoAntes = window.localStorage.getItem(CLAVE_AVISO) === '1'; } catch (e) {}

      function abrir() {
        aviso.classList.add('mt-abierto');
        aviso.setAttribute('aria-hidden', 'false');
        if (pestana) pestana.classList.remove('mt-pestana--visible');
        /* El foco automatico SOLO en pantallas grandes. En el movil abre el
           teclado de golpe nada mas aparecer el aviso, y ademas el navegador
           mueve la pagina para dejar el campo a la vista. Con preventScroll
           se le pide que no toque el desplazamiento. */
        var campo = aviso.querySelector('input[type=email]');
        var pantallaGrande = window.matchMedia('(min-width: 750px)').matches;
        if (campo && pantallaGrande) {
          setTimeout(function () {
            try { campo.focus({ preventScroll: true }); } catch (e) {}
          }, 380);
        }
      }

      function cerrar(recordar) {
        aviso.classList.remove('mt-abierto');
        aviso.setAttribute('aria-hidden', 'true');
        if (recordar) {
          try { window.localStorage.setItem(CLAVE_AVISO, '1'); } catch (e) {}
        }
        // la pestaña entra deslizandose desde fuera de la pagina
        if (pestana) setTimeout(function () { pestana.classList.add('mt-pestana--visible'); }, 260);
      }

      Array.prototype.forEach.call(aviso.querySelectorAll('[data-mt-aviso-cerrar]'), function (b) {
        b.addEventListener('click', function () { cerrar(true); });
      });

      aviso.addEventListener('click', function (ev) {
        if (ev.target === aviso) cerrar(true);
      });

      document.addEventListener('keydown', function (ev) {
        if (ev.key === 'Escape' && aviso.classList.contains('mt-abierto')) cerrar(true);
      });

      if (pestana && !pestana.dataset.mtInit) {
        pestana.dataset.mtInit = '1';
        pestana.addEventListener('click', function () {
          // primero se va de la pagina, luego aparece el aviso
          pestana.classList.remove('mt-pestana--visible');
          setTimeout(abrir, 240);
        });
      }

      /* Cerrar despues de suscribirse: se recuerda para que no vuelva a salir,
         pero NO se saca la pestaña lateral. Esa pestaña ofrece el 10% a quien
         lo rechazo; a quien ya se ha suscrito le sobra. */
      Array.prototype.forEach.call(aviso.querySelectorAll('[data-mt-aviso-fin]'), function (b) {
        b.addEventListener('click', function () {
          aviso.classList.remove('mt-abierto');
          aviso.setAttribute('aria-hidden', 'true');
          try { window.localStorage.setItem(CLAVE_AVISO, '1'); } catch (e) {}
        });
      });

      function mostrarOk() {
        var ok = aviso.querySelector('[data-mt-aviso-ok]');
        var pedir = aviso.querySelector('[data-mt-aviso-pedir]');
        if (ok) ok.hidden = false;
        if (pedir) pedir.hidden = true;
        try { window.localStorage.setItem(CLAVE_AVISO, '1'); } catch (e) {}
      }

      /* PROBADO EN LA TIENDA EN VIVO: mandar este formulario a un iframe
         oculto NO funciona. La pagina se quedaba quieta y el aviso decia
         "You're in", pero el cliente no se creaba nunca. Estuvo asi un rato
         y no entro ni un suscriptor. No repetirlo.

         Se vuelve al envio de toda la vida, que si guarda. Lo que se arregla
         es el salto:
           1. El id del formulario ya es unico (mt-aviso-form). Antes salia
              id="contact_form" igual que el de la newsletter del pie, y el
              navegador saltaba al primero del documento, que es el del pie.
           2. Se le quita el "#..." al action, para que al volver no haya
              ningun ancla a la que saltar.
           3. Se guarda la posicion antes de enviar y se recupera al volver.
         Resultado: la pagina parpadea al recargar, pero se queda donde
         estaba y el aviso vuelve abierto con el mensaje de exito. */
      var formulario = aviso.querySelector('form');
      if (formulario) {
        var acc = formulario.getAttribute('action');
        if (acc) formulario.setAttribute('action', acc.split('#')[0]);
        formulario.addEventListener('submit', guardarScroll);
      }

      var yaSuscrito = window.location.search.indexOf('customer_posted=true') > -1;
      if (yaSuscrito) {
        recuperarScroll();
        mostrarOk();
        abrir();
        return;
      }

      if (cerradoAntes) {
        if (pestana) setTimeout(function () { pestana.classList.add('mt-pestana--visible'); }, 900);
      } else {
        setTimeout(abrir, retraso);
      }
    });
  }

  /* --- Newsletter: mensaje de exito -------------------------------------- */
  function initNewsletter(raiz) {
    var bloques = (raiz || document).querySelectorAll('[data-mt-newsletter]');
    Array.prototype.forEach.call(bloques, function (bloque) {
      if (bloque.dataset.mtInit) return;
      bloque.dataset.mtInit = '1';

      var form = bloque.querySelector('form');

      function mostrarOk() {
        var ok = bloque.querySelector('[data-mt-newsletter-ok]');
        if (ok) ok.hidden = false;
        if (form) form.hidden = true;
      }

      /* Mismo criterio que en el aviso del 10%: envio nativo, sin iframe.
         Ver el comentario de initAviso. */
      if (form) {
        var acc = form.getAttribute('action');
        if (acc) form.setAttribute('action', acc.split('#')[0]);
        form.addEventListener('submit', guardarScroll);
      }

      if (window.location.search.indexOf('customer_posted=true') > -1) {
        recuperarScroll();
        mostrarOk();
      }
    });
  }

  /* --- Pagina de producto: packs, colores y galeria ----------------------- */
  function initProducto(raiz) {
    var bloques = (raiz || document).querySelectorAll('[data-mt-producto]');
    Array.prototype.forEach.call(bloques, function (bloque) {
      if (bloque.dataset.mtInit) return;
      bloque.dataset.mtInit = '1';

      var principal = bloque.querySelector('[data-mt-galeria-principal]');
      var tiras = bloque.querySelectorAll('[data-mt-galeria-tira]');
      var campoId = bloque.querySelector('[data-mt-variante-id]');
      var campoCantidad = bloque.querySelector('[data-mt-cantidad]');
      var totalActual = bloque.querySelector('[data-mt-total-actual]');
      var totalAntes = bloque.querySelector('[data-mt-total-antes]');
      var totalAhorro = bloque.querySelector('[data-mt-total-ahorro]');
      var nombreColor = bloque.querySelector('[data-mt-color-elegido]');
      var formulario = bloque.querySelector('.mt-compra');
      var acelerado = bloque.querySelector('[data-mt-acelerado]');
      var nota = bloque.querySelector('[data-mt-nota]');
      var textoNota = nota ? nota.textContent : '';
      var textoMezclado = bloque.getAttribute('data-mt-mezclado') || 'Mixed';
      var swatches = bloque.querySelectorAll('[data-mt-variante]');
      var packs = bloque.querySelectorAll('[data-mt-pack]');
      var paneles = bloque.querySelectorAll('[data-mt-pack-colores]');

      function marcarTira(url) {
        Array.prototype.forEach.call(tiras, function (t) {
          t.classList.toggle('mt-activo', t.getAttribute('data-mt-galeria-tira') === url);
        });
      }

      /* --- Galeria ------------------------------------------------------- */
      Array.prototype.forEach.call(tiras, function (tira) {
        tira.addEventListener('click', function () {
          var url = tira.getAttribute('data-mt-galeria-tira');
          if (principal && url) principal.setAttribute('src', url);
          marcarTira(url);
        });
      });

      /* --- Panel de colores de cada pack --------------------------------- */
      Array.prototype.forEach.call(paneles, function (panel) {
        panel.classList.add('mt-pack__colores--js');
        if (!panel.hidden) panel.style.height = 'auto';
      });

      function abrirPanel(panel) {
        if (!panel || !panel.hidden) return;
        panel.hidden = false;
        panel.style.height = '0px';
        void panel.offsetHeight;
        abrirCuerpo(panel);
      }

      function cerrarPanel(panel) {
        if (!panel || panel.hidden) return;
        cerrarCuerpo(panel);
        if (sinMovimiento) { panel.hidden = true; return; }
        var fin = function () {
          panel.hidden = true;
          panel.removeEventListener('transitionend', fin);
        };
        panel.addEventListener('transitionend', fin);
      }

      /* --- Estado de la seleccion ---------------------------------------- */
      function packActivo() {
        for (var i = 0; i < packs.length; i++) {
          if (packs[i].classList.contains('mt-activo')) return packs[i];
        }
        return packs.length ? packs[0] : null;
      }

      function panelDe(pack) {
        if (!pack || !pack.parentNode) return null;
        return pack.parentNode.querySelector('[data-mt-pack-colores]');
      }

      function cantidadDe(pack) {
        if (!pack) return 1;
        return parseInt(pack.getAttribute('data-mt-pack'), 10) || 1;
      }

      function variantePrincipal() {
        for (var i = 0; i < swatches.length; i++) {
          if (swatches[i].classList.contains('mt-activo')) return swatches[i].getAttribute('data-mt-variante');
        }
        return campoId ? campoId.value : null;
      }

      /* Devuelve una entrada por unidad. Con un solo articulo es la variante
         del selector grande; con packs, lo elegido en cada fila del panel. */
      function seleccionActual() {
        var pack = packActivo();
        var cantidad = cantidadDe(pack);
        var panel = panelDe(pack);
        if (cantidad <= 1 || !panel) {
          var ids = [];
          for (var i = 0; i < cantidad; i++) ids.push(variantePrincipal());
          return ids;
        }
        var elegidas = [];
        Array.prototype.forEach.call(panel.querySelectorAll('.mt-unidad'), function (unidad) {
          var activa = unidad.querySelector('.mt-mini.mt-activo') || unidad.querySelector('.mt-mini');
          if (activa) elegidas.push(activa.getAttribute('data-mt-mini'));
        });
        return elegidas.length ? elegidas : [variantePrincipal()];
      }

      function hayMezcla(ids) {
        for (var i = 1; i < ids.length; i++) {
          if (ids[i] !== ids[0]) return true;
        }
        return false;
      }

      function actualizarEstado() {
        var ids = seleccionActual();
        var mezcla = hayMezcla(ids);

        if (campoId && ids.length) campoId.value = ids[0];
        if (campoCantidad) campoCantidad.value = ids.length;

        /* Shop Pay solo sabe llevar una variante: con colores distintos
           compraria otra cosa distinta de la que se ve en pantalla. */
        if (acelerado) acelerado.hidden = mezcla;
        if (nota) { nota.textContent = textoNota; nota.hidden = !mezcla; }

        if (nombreColor) {
          if (mezcla) {
            nombreColor.textContent = textoMezclado;
          } else {
            var boton = null;
            Array.prototype.forEach.call(swatches, function (sw) {
              if (sw.getAttribute('data-mt-variante') === ids[0]) boton = sw;
            });
            if (boton) nombreColor.textContent = boton.getAttribute('data-mt-nombre') || '';
          }
        }
      }

      /* --- Selector grande de color: manda sobre todas las unidades ------- */
      function marcarMini(unidad, id) {
        Array.prototype.forEach.call(unidad.querySelectorAll('.mt-mini'), function (m) {
          var activo = m.getAttribute('data-mt-mini') === id;
          m.classList.toggle('mt-activo', activo);
          m.setAttribute('aria-pressed', activo ? 'true' : 'false');
          if (activo) {
            var etiqueta = unidad.querySelector('[data-mt-unidad-nombre]');
            if (etiqueta) etiqueta.textContent = m.getAttribute('data-mt-nombre') || '';
          }
        });
      }

      Array.prototype.forEach.call(swatches, function (swatch) {
        swatch.addEventListener('click', function () {
          var id = swatch.getAttribute('data-mt-variante');

          Array.prototype.forEach.call(swatches, function (sw) {
            sw.classList.remove('mt-activo');
            sw.setAttribute('aria-pressed', 'false');
          });
          swatch.classList.add('mt-activo');
          swatch.setAttribute('aria-pressed', 'true');

          // el circulo grande pone ese color en todas las unidades de todos los packs
          Array.prototype.forEach.call(bloque.querySelectorAll('.mt-unidad'), function (unidad) {
            marcarMini(unidad, id);
          });

          var url = swatch.getAttribute('data-mt-imagen');
          if (url && principal) {
            principal.setAttribute('src', url);
            marcarTira(url);
          }
          actualizarEstado();
        });
      });

      /* --- Cuadrados de color por unidad ----------------------------------
         Ya no hay selector de color suelto: la foto grande sigue al color de
         la PRIMERA unidad del pack que este seleccionado.                  */
      function sincronizarGaleria() {
        if (!principal) return;
        var panel = panelDe(packActivo());
        if (!panel) return;
        var primera = panel.querySelector('.mt-unidad .mt-mini.mt-activo');
        if (!primera) return;
        var url = primera.getAttribute('data-mt-imagen');
        if (!url) return;
        principal.setAttribute('src', url);
        marcarTira(url);
      }

      Array.prototype.forEach.call(bloque.querySelectorAll('.mt-mini'), function (mini) {
        mini.addEventListener('click', function () {
          var unidad = mini.closest ? mini.closest('.mt-unidad') : null;
          if (!unidad) return;
          marcarMini(unidad, mini.getAttribute('data-mt-mini'));
          sincronizarGaleria();
          actualizarEstado();
        });
      });

      /* --- Packs ---------------------------------------------------------- */
      Array.prototype.forEach.call(packs, function (pack) {
        pack.addEventListener('click', function () {
          Array.prototype.forEach.call(packs, function (p) {
            p.classList.remove('mt-activo');
            p.setAttribute('aria-pressed', 'false');
            p.setAttribute('aria-expanded', 'false');
            if (p.parentNode) p.parentNode.classList.remove('mt-activo');
            cerrarPanel(panelDe(p));
          });
          pack.classList.add('mt-activo');
          pack.setAttribute('aria-pressed', 'true');
          if (pack.parentNode) pack.parentNode.classList.add('mt-activo');

          var panel = panelDe(pack);
          if (panel) {
            pack.setAttribute('aria-expanded', 'true');
            abrirPanel(panel);
          }

          if (totalActual) totalActual.textContent = pack.getAttribute('data-mt-total') || '';
          if (totalAntes) {
            var antes = pack.getAttribute('data-mt-antes');
            if (antes) { totalAntes.textContent = antes; totalAntes.hidden = false; }
            else { totalAntes.hidden = true; }
          }
          if (totalAhorro) {
            var ahorro = pack.getAttribute('data-mt-ahorro');
            if (ahorro) { totalAhorro.textContent = ahorro; totalAhorro.hidden = false; }
            else { totalAhorro.hidden = true; }
          }
          sincronizarGaleria();
          actualizarEstado();
        });
      });

      /* --- Anadir al carrito ---------------------------------------------
         Un formulario normal de Shopify solo sabe mandar UNA variante. Para
         un pack de colores distintos hay que pasar por /cart/add.js, que
         acepta varias lineas de golpe.                                     */
      if (formulario) {
        formulario.addEventListener('submit', function (ev) {
          var ids = seleccionActual();
          if (ids.length <= 1) return; // el envio normal del navegador ya vale

          ev.preventDefault();

          var cuenta = {};
          var orden = [];
          ids.forEach(function (id) {
            if (!cuenta[id]) { cuenta[id] = 0; orden.push(id); }
            cuenta[id] += 1;
          });
          var lineas = orden.map(function (id) {
            return { id: parseInt(id, 10), quantity: cuenta[id] };
          });

          var raizTienda = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          var boton = formulario.querySelector('button[name="add"]');
          var textoBoton = boton ? boton.textContent : '';
          if (boton) { boton.disabled = true; boton.textContent = 'Adding…'; }

          fetch(raizTienda + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: lineas })
          })
            .then(function (r) {
              return r.json().then(function (datos) { return { ok: r.ok, datos: datos }; });
            })
            .then(function (res) {
              if (!res.ok) throw new Error((res.datos && res.datos.description) || 'No se pudo anadir');
              window.location.href = raizTienda + 'cart';
            })
            .catch(function (error) {
              if (boton) { boton.disabled = false; boton.textContent = textoBoton; }
              if (nota) {
                nota.textContent = 'Something went wrong adding this to your cart. Please try again.';
                nota.hidden = false;
              }
              if (window.console) window.console.error('[dorantea] carrito:', error);
            });
        });
      }

      actualizarEstado();
    });
  }

  /* --- Resenas: abrir la ficha completa al tocar -------------------------
     Con raton basta el :hover del CSS. En tactil no hay hover, asi que la
     capa transparente de encima hace de interruptor.                      */
  function initResenas(raiz) {
    var viajes = (raiz || document).querySelectorAll('[data-mt-resenas]');
    Array.prototype.forEach.call(viajes, function (viaje) {
      if (viaje.dataset.mtInit) return;
      viaje.dataset.mtInit = '1';

      var pista = viaje.querySelector('.mt-resenas__pista');
      var lupas = viaje.querySelectorAll('.mt-resena__lupa');

      function cerrarTodas() {
        Array.prototype.forEach.call(lupas, function (l) {
          var t = l.parentNode;
          if (t) t.classList.remove('mt-activo');
          l.setAttribute('aria-expanded', 'false');
        });
        if (pista) pista.style.animationPlayState = '';
      }

      Array.prototype.forEach.call(lupas, function (lupa) {
        lupa.addEventListener('click', function (ev) {
          ev.preventDefault();
          var tarjeta = lupa.parentNode;
          if (!tarjeta) return;
          var abierta = tarjeta.classList.contains('mt-activo');
          cerrarTodas();
          if (!abierta) {
            tarjeta.classList.add('mt-activo');
            lupa.setAttribute('aria-expanded', 'true');
            if (pista) pista.style.animationPlayState = 'paused';
          }
        });
      });

      document.addEventListener('click', function (ev) {
        if (viaje.contains(ev.target)) return;
        cerrarTodas();
      });
    });
  }

  /* --- Arranque ----------------------------------------------------------- */
  function initTodo(raiz) {
    initReveals(raiz);
    initAnclas(raiz);
    initHotspots(raiz);
    initFaq(raiz);
    initBotonMagnetico(raiz);
    initMarquesina(raiz);
    initNewsletter(raiz);
    initAviso(raiz);
    initProducto(raiz);
    initResenas(raiz);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initTodo(document); });
  } else {
    initTodo(document);
  }

  document.addEventListener('shopify:section:load', function (ev) {
    initTodo(ev.target || document);
  });
})();

/* v23.1 */
